// extracted by mini-css-extract-plugin
export default {"root":"Programs_root__QZvFV","container":"Programs_container__XCCV+","grid":"Programs_grid__gqJiK","programs-btn":"Programs_programs-btn__V6Avq","text":"Programs_text__VErci"};